// Data seam for Stock Investments — the buckets one brokerage account is split
// into — and the hand-entered Starting Values the section summaries use.

import { request } from './portfolio';

/** Resolves to `{ buckets, allocations, defaultBucket }`. */
export const getStocks = () => request('stocks');

/** Replaces every allocation of `symbol`; an empty list returns it all to the
 *  default bucket. Each allocation is `{ bucket, quantity, costBasis }`. */
export const setAllocations = (symbol, allocations) =>
  request(`stocks/allocations/${encodeURIComponent(symbol)}`, {
    method: 'PUT',
    body: JSON.stringify({ allocations }),
  });

export const createBucket = (name) =>
  request('stocks/buckets', { method: 'POST', body: JSON.stringify({ name }) });

/** The account's time-weighted return against the S&P 500 and NASDAQ, plus
 *  each held symbol's price return: `{ from, to, series, unavailable, symbols }`. */
export const getStockBenchmarks = () => request('stocks/benchmarks');

/** Resolves to `{ inputs }`, keyed as `start:<part>`. */
export const getSummaryInputs = () => request('stocks/inputs');

/** Sets a Starting Value, or clears it with null. Resolves to `{ inputs }`. */
export const setSummaryInput = (key, value) =>
  request('stocks/inputs', { method: 'PUT', body: JSON.stringify({ key, value }) });
